import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { FormsListControllerModule } from './controllers/FormsListController';

export const FormsListView = angular
  .module('acme.view.application.forms.list', [uiRouter, 'ui.bootstrap', FormsListControllerModule])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.forms.list',
      url: '/list',
      views: {
        'subview-main': {
          controller: 'FormsListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/forms/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Forms',
        /** Secure With Permissions **/
        permissions: ['FORMS_VIEW'],
      },
    });
  }).name;
